// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","large":"only screen and (min-width: 992px)","filterItem":"_2d1ds _1R_Wx V16Wa","labelItem":"_2o8GQ","icon":"O6zrv"};